import type { IconProps } from './../../models/icon';

export function XIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          d="M22.5344 5.20766C22.8694 4.86862 23.0573 4.41122 23.0573 3.93461C23.0573 3.45801 22.8694 3.00062 22.5344 2.66158L21.2528 1.38C20.918 1.07015 20.4786 0.898029 20.0225 0.898029C19.5663 0.898029 19.1269 1.07015 18.7921 1.38L11.9571 8.12966L5.20741 1.38C4.86838 1.04502 4.41097 0.857178 3.93437 0.857178C3.45776 0.857178 3.00037 1.04502 2.66134 1.38L1.37975 2.66158C1.04478 3.00062 0.856934 3.45801 0.856934 3.93461C0.856934 4.41122 1.04478 4.86862 1.37975 5.20766L8.21485 12.0428L1.37975 18.7924C1.04478 19.1315 0.856934 19.5888 0.856934 20.0654C0.856934 20.542 1.04478 20.9995 1.37975 21.3384L2.66134 22.62C3.00037 22.955 3.45776 23.1429 3.93437 23.1429C4.41097 23.1429 4.86838 22.955 5.20741 22.62L11.9571 15.785L18.7921 22.5347C19.1312 22.8696 19.5886 23.0575 20.0652 23.0575C20.5417 23.0575 20.9993 22.8696 21.3382 22.5347L22.6198 21.2531C22.9548 20.914 23.1426 20.4566 23.1426 19.98C23.1426 19.5035 22.9548 19.0461 22.6198 18.707L15.7847 11.9573L22.5344 5.20766Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M22.5344 5.20766C22.8694 4.86862 23.0573 4.41122 23.0573 3.93461C23.0573 3.45801 22.8694 3.00062 22.5344 2.66158L21.2528 1.38C20.918 1.07015 20.4786 0.898029 20.0225 0.898029C19.5663 0.898029 19.1269 1.07015 18.7921 1.38L11.9571 8.12966L5.20741 1.38C4.86838 1.04502 4.41097 0.857178 3.93437 0.857178C3.45776 0.857178 3.00037 1.04502 2.66134 1.38L1.37975 2.66158C1.04478 3.00062 0.856934 3.45801 0.856934 3.93461C0.856934 4.41122 1.04478 4.86862 1.37975 5.20766L8.21485 12.0428L1.37975 18.7924C1.04478 19.1315 0.856934 19.5888 0.856934 20.0654C0.856934 20.542 1.04478 20.9995 1.37975 21.3384L2.66134 22.62C3.00037 22.955 3.45776 23.1429 3.93437 23.1429C4.41097 23.1429 4.86838 22.955 5.20741 22.62L11.9571 15.785L18.7921 22.5347C19.1312 22.8696 19.5886 23.0575 20.0652 23.0575C20.5417 23.0575 20.9993 22.8696 21.3382 22.5347L22.6198 21.2531C22.9548 20.914 23.1426 20.4566 23.1426 19.98C23.1426 19.5035 22.9548 19.0461 22.6198 18.707L15.7847 11.9573L22.5344 5.20766Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <rect width="24" height="24" fill="transparent" />
        </clipPath>
      </defs>
    </svg>
  );
}
